// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon_FTwEo {
  display : inline-flex;
  width : 40px;
  height : 40px;
  align-items:center;
  justify-content:center;
}

.icon_FTwEo:hover {
  background-color:var( --light-grey );
}

.list_S5V2h {
  width : 180px;
  height : 250px;
  overflow-y:auto;
  overflow-x:hidden;
}

.menu_wykwe .filter_tmG5B {
  margin:5px;
  border-radius:0;
  width:initial !important;
}

.noFontSelected_VVzF_ {
  display : inline-block;
  color : var( --light-grey );
  width : 40px;
  font-size: 11px;
}

.fontSelected_CfNL9 {
  display : inline-block;
  text-align:center;
  width : 40px
}`, "",{"version":3,"sources":["webpack://./src/views/fonticonselector.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB;AACF","sourcesContent":["@import \"../style/theme.css\";\n\n.icon {\n  display : inline-flex;\n  width : 40px;\n  height : 40px;\n  align-items:center;\n  justify-content:center;\n}\n\n.icon:hover {\n  background-color:var( --light-grey );\n}\n\n.list {\n  width : 180px;\n  height : 250px;\n  overflow-y:auto;\n  overflow-x:hidden;\n}\n\n.menu .filter {\n  margin:5px;\n  border-radius:0;\n  width:initial !important;\n}\n\n.noFontSelected {\n  display : inline-block;\n  color : var( --light-grey );\n  width : 40px;\n  font-size: 11px;\n}\n\n.fontSelected {\n  display : inline-block;\n  text-align:center;\n  width : 40px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `icon_FTwEo`,
	"list": `list_S5V2h`,
	"menu": `menu_wykwe`,
	"filter": `filter_tmG5B`,
	"noFontSelected": `noFontSelected_VVzF_`,
	"fontSelected": `fontSelected_CfNL9`
};
export default ___CSS_LOADER_EXPORT___;
